<template>
    <b-modal
        id="AccountSearchSelect_CreateAccountModal"
        v-model="shown"
        centered
        title="Create Account"
        size="lg"
        lazy
    >

        <Spinner v-if="loading" />
        <div v-else>

            <!-- Account Name -->
            <b-form-group
                label="Account Name"
                label-for="AccountSearchSelect_CreateAccountModal_AccountNameInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountNameInput"
                    v-model="account.name"
                    placeholder="Enter a name..."
                />
                <b-form-invalid-feedback :force-show="!$v.account.name.required">
                    Please enter an account name.
                </b-form-invalid-feedback>
            </b-form-group>
            <!--/ Account Name -->

            <!-- Account Address -->
            <b-form-group
                label="Account Address"
                label-for="AccountSearchSelect_CreateAccountModal_AccountAddressTextarea"
                :label-cols="labelCols"
            >
                <b-form-textarea
                    id="AccountSearchSelect_CreateAccountModal_AccountAddressTextarea"
                    v-model="account.address"
                />
            </b-form-group>
            <!--/ Account Address -->

            <!-- Account Address Line 2 -->
            <b-form-group
                label="Account Address Line 2"
                label-for="AccountSearchSelect_CreateAccountModal_AccountAddressLine2Input"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountAddressLine2Input"
                    v-model="account.addressLine2"
                />
            </b-form-group>
            <!--/ Account Address Line 2 -->

            <!-- Account Address Line 3 -->
            <b-form-group
                label="Account Address Line 3"
                label-for="AccountSearchSelect_CreateAccountModal_AccountAddressLine3Input"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountAddressLine3Input"
                    v-model="account.addressLine3"
                />
            </b-form-group>
            <!--/ Account Address Line 3 -->

            <!-- Account City -->
            <b-form-group
                label="Account City"
                label-for="AccountSearchSelect_CreateAccountModal_AccountCityInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountCityInput"
                    v-model="account.city"
                />
            </b-form-group>
            <!--/ Account City -->

            <!-- Account Region -->
            <b-form-group
                label="Account Region"
                label-for="AccountSearchSelect_CreateAccountModal_AccountRegionInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountRegionInput"
                    v-model="account.region"
                />
            </b-form-group>
            <!--/ Account Region -->

            <!-- Account Postcode -->
            <b-form-group
                label="Account Postcode"
                label-for="AccountSearchSelect_CreateAccountModal_AccountPostcodeInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountPostcodeInput"
                    v-model="account.postcode"
                />
            </b-form-group>
            <!--/ Account Postcode -->

            <!-- Account Country -->
            <b-form-group
                label="Account Country"
                label-for="AccountSearchSelect_CreateAccountModal_AccountCountryInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountCountryInput"
                    v-model="account.country"
                />
            </b-form-group>
            <!--/ Account Country -->

            <hr>

            <!-- Invoice Address-->
            <b-form-group
                label="Invoice Address"
                label-for="AccountSearchSelect_CreateAccountModal_InvoiceAddressTextarea"
                :label-cols="labelCols"
            >
                <b-form-textarea
                    id="AccountSearchSelect_CreateAccountModal_InvoiceAddressTextarea"
                    v-model="account.invoice.address"
                />
            </b-form-group>
            <!--/ Invoice Address -->

            <!-- Invoice City -->
            <b-form-group
                label="Invoice City"
                label-for="AccountSearchSelect_CreateAccountModal_InvoiceCityInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_InvoiceCityInput"
                    v-model="account.invoice.city"
                />
            </b-form-group>
            <!--/ Invoice City -->

            <!-- Invoice Region -->
            <b-form-group
                label="Invoice Region"
                label-for="AccountSearchSelect_CreateAccountModal_InvoiceRegionInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_InvoiceRegionInput"
                    v-model="account.invoice.region"
                />
            </b-form-group>
            <!--/ Invoice Region -->

            <!-- Invoice Postcode -->
            <b-form-group
                label="Invoice Postcode"
                label-for="AccountSearchSelect_CreateAccountModal_InvoicePostcodeInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_InvoicePostcodeInput"
                    v-model="account.invoice.postcode"
                />
            </b-form-group>
            <!--/ Invoice Postcode -->

            <!-- Invoice Country -->
            <b-form-group
                label="Invoice Country"
                label-for="AccountSearchSelect_CreateAccountModal_InvoiceCountryInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_InvoiceCountryInput"
                    v-model="account.invoice.country"
                />
            </b-form-group>
            <!--/ Invoice Country -->

            <hr>
            <!-- Teams -->
            <b-form-group
                    label="Teams"
                    label-for="EventCosts_CostsCard_AddCostModal_AccountTeamsCheckbox"
                    :label-cols="labelCols"
            >
                <Select
                        id="EventCosts_CostsCard_AddCostModal_AccountTeamsCheckbox"
                        v-model="account.teams"
                        placeholder="Select a team..."
                        action="selects/getTeams"
                        track-by="name"
                        label="label"
                        :multiple="true"
                />
            </b-form-group>
            <!--/ Teams -->

            <!-- Phone -->
            <b-form-group
                label="Phone"
                label-for="AccountSearchSelect_CreateAccountModal_AccountPhoneInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountPhoneInput"
                    v-model="account.phone"
                />
            </b-form-group>
            <!--/ Phone -->

            <!-- Facebook -->
            <b-form-group
                class="form-input-modal-facebook"
                label="Facebook"
                label-for="AccountSearchSelect_CreateAccountModal_AccountFacebookInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountFacebookInput"
                    v-model="account.facebook"
                />
            </b-form-group>
            <!--/ Facebook -->

            <!-- LinkedIn -->
            <b-form-group
                class="form-input-modal-linkedin"
                label="LinkedIn"
                label-for="AccountSearchSelect_CreateAccountModal_AccountLinkedInInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountLinkedInInput"
                    v-model="account.linkedIn"
                />
            </b-form-group>
            <!--/ LinkedIn -->

            <!-- Fax -->
            <b-form-group
                class="form-input-modal-fax"
                label="Fax"
                label-for="AccountSearchSelect_CreateAccountModal_AccountFaxInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountFaxInput"
                    v-model="account.fax"
                />
            </b-form-group>
            <!--/ Fax -->

            <!-- Website -->
            <b-form-group
                class="form-input-modal-website"
                label="Website"
                label-for="AccountSearchSelect_CreateAccountModal_AccountWebsiteInput"
                :label-cols="labelCols"
            >
                <b-form-input
                    id="AccountSearchSelect_CreateAccountModal_AccountWebsiteInput"
                    v-model="account.website"
                />
            </b-form-group>
            <!--/ Website -->

            <!-- Account Type -->
            <b-form-group
                label="Account Type"
                label-for="EventCosts_CostsCard_AddCostModal_AccountTypesCheckbox"
                :label-cols="labelCols"
            >
                <b-form-checkbox
                    v-for="type in accountTypes"
                    v-model="account.types"
                    :key="type.id"
                    :value="type.id"
                >
                    {{ type.label }}
                </b-form-checkbox>
            </b-form-group>
            <!--/ Account Type -->

            <!-- Industry Type -->
            <b-form-group
                label="Type"
                label-for="EventCosts_CostsCard_AddCostModal_AccountIndustryTypeCheckbox"
                :label-cols="labelCols"
            >
                <Select
                    id="EventCosts_CostsCard_AddCostModal_AccountIndustryTypeCheckbox"
                    v-model="account.industryType"
                    placeholder="Select a type..."
                    action="selects/getIndustryTypes"
                    track-by="name"
                    label="label"
                    :multiple="false"
                />
            </b-form-group>
            <!--/ Industry Type -->

            <!-- Source -->
            <b-form-group
                label="Source"
                label-for="EventCosts_CostsCard_AddCostModal_AccountSource"
                :label-cols="labelCols"
            >
                <Select
                    id="EventCosts_CostsCard_AddCostModal_AccountSource"
                    v-model="account.source"
                    placeholder="Select a source..."
                    action="selects/getSources"
                    track-by="name"
                    label="label"
                    :multiple="false"
                />
            </b-form-group>
            <!--/ Source -->

            <div v-if="errors" class="alert  alert-danger py-2 font-bold mb-4">
                <div v-for="(v, k) in errors" :key="k">
                    <p v-for="error in v" :key="error" class="text-sm">
                        {{ error }}
                    </p>
                </div>
            </div>

        </div>

        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="close()"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :disabled="loading || $v.$invalid"
                :loading="submitLoading"
                @click="handleSubmit()"
            >
                Create
            </Button>
        </div>

    </b-modal>
</template>

<script>
import required from 'vuelidate/lib/validators/required';
import vueComponentReset from '@ianwalter/vue-component-reset';
import api from '@/api';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    loading: false,
    submitLoading: false,
    account: {
        name: '',
        address: '',
        addressLine2: '',
        addressLine3: '',
        city: '',
        region: '',
        postcode: '',
        country: '',
        invoice: {
            address: '',
            city: '',
            region: '',
            postcode: '',
            country: '',
        },
        phone: '',
        facebook: '',
        linkedIn: '',
        fax: '',
        website: '',
        isClient: false,
        isSupplier: false,
        isAgent: false,
        isVenue: false,
        accountType: {},
        industryType: {},
        teams: {},
        types: [],
        source: {},
    },
}));

export default {

    mixins: [resetMixin],

    data() {
        return {
            labelCols: 4,
            errors: null,
            accountTypes: [],
        }
    },

    created() {
        this.$eventBus.$on(this.$events.openCreateAccountModal, (e) => {
            this.$v.$reset();
            this.reset();
            this.account.name = e.accountName;
            this.$store.dispatch('selects/getAccountTypes').then(response => {
                this.accountTypes = response;
            });
            this.$store.dispatch('selects/getUserTeam').then(response => {
                this.account.teams = response;
            });
            this.shown = true;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            try {
                const newAccount = await api.createAccount(this.account);
                this.$eventBus.$emit(this.$events.createAccountModalSuccess, { newAccount });
                this.submitLoading = false;
                this.close();
            } catch (error) {
                this.errors = error;
                this.submitLoading = false;
            }
        },
        close() {
            this.shown = false;
        },
    },

    validations: {
        account: {
            name: {
                required,
            },
        },
    },

};
</script>
